import "angular";
import LogDecorator from "./LogDecorator";

const moduleName = "LoggerModule";
const moduleDependencies = [];

const LoggerModule = angular.module(moduleName, moduleDependencies).config(LogDecorator);

export default LoggerModule;
